import i18next from 'i18next';
import { numberValidate, numberHyphenValidate } from './regex';

export const validate = data => {
  const errors = {};

  // Reward
  if (!data.reward) {
    errors.reward = i18next.t('reward_amount_validate');
  } else if (data.reward && !numberValidate(data.reward)) {
    errors.reward = i18next.t('value_must_be_number');
  }

  //   Points
  if (!data.place) {
    errors.place = i18next.t('ranking_place_validate');
  } else if (data.place && !numberHyphenValidate(data.place)) {
    errors.place = i18next.t('value_must_be_number');
  }

  return errors;
};
